import { FunctionComponent } from 'react';
import { Typography } from '@material-ui/core';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import SelectProduct from './SelectProduct';
import { Product } from '@spike/product-model';

interface Props {
    selectedOption?: Product;
    options: Array<Product>;
    onSelectProduct: (product: Product) => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        title: {
            fontWeight: 600,
            fontSize: 16,
            lineHeight: '16px',
            marginBottom: 18,
            [theme.breakpoints.up('md')]: {
                marginBottom: 20
            }
        }
    })
);

export const ProductComponent: FunctionComponent<Props> = props => {
    const classes = useStyles();

    return (
        <>
            <Typography className={classes.title}>Product</Typography>
            <SelectProduct
                placeholder="Select Product"
                selectedOption={props.selectedOption}
                options={props.options}
                onSelect={props.onSelectProduct}
            />
        </>
    );
};

export default ProductComponent;
